import { render, staticRenderFns } from "./ServiceIndicator.vue?vue&type=template&id=57bfbf3f&"
import script from "./ServiceIndicator.vue?vue&type=script&lang=ts&"
export * from "./ServiceIndicator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports